// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1e5O3","unreadBadge":"styles_unreadBadge__3r89S","modalContent":"styles_modalContent__7UMuj","modal":"styles_modal__1Nrur"};